import {Heading, Text, Box, Center, Card, CardHeader, CardBody, Icon, Stat, StatHelpText} from "@chakra-ui/react"
import { ChevronRightIcon } from '@chakra-ui/icons'; // Import an icon
import { Helmet } from 'react-helmet';
import {Link} from "react-router-dom";

export default function Blog() {
    return (
    <>
    <Helmet>
      <title>Ką rengtis pagal Viliją Rušinskaitę - Tinklaraštis</title>
      <meta name="description" content="Vilijos Rušinskaitės tinklaraštis" />
      <meta property="og:title" content="Tinklaraštis" />
      <meta property="og:description" content="Vilijos Rušinskaitės tinklaraštis" />
      <meta property="og:image" content="https://karengtis.lt/vilija1_small.jpg" />
      <meta property="og:url" content="https://www.karengtis.lt/blog" />
    </Helmet>
    <Box minH='2vw' />
    {/* <Center>
    <Card border='1px' maxWidth="80vw" minWidth='80vw' shadow='none'>
      <CardHeader >
        <Box minH='1vw' />
        <Center>
          <Heading as='h1' sx={{ fontSize: '32px', fontFamily: 'Montserrat, sans-serif' }}>Tinklaraštis</Heading>
        </Center>
        <Box minH='1vw' />
      </CardHeader>
    </Card>
    </Center>
    <Box minH='2vw' /> */}
    <Center>
    <Card border='1px' maxWidth="80vw" minWidth='60vw' shadow='none'>
      <CardHeader >
        <Box minH='1vw' />
        <Center>
          <Heading as='h1' sx={{ fontSize: '32px', fontFamily: 'Montserrat, sans-serif' }}>Apie kalėdinį laikotarpį</Heading>
        </Center>
        <Box>
            <Stat>
                <StatHelpText mb='0' mt='4'>2025-11-07 </StatHelpText>
            </Stat>
        </Box>
      </CardHeader>
    <Center>
    <CardBody pt='0'>

        <Box>
          <Text pt='2' fontSize='xl'>
          Kiek tyros vaikystės magijos kalėdinis laikotarpis jums vis dar turi? Atsakykit nuoširdžiai, nenumoję ranka į visus dovanų sąrašus, darbinius vakarėlius, gaminimo virtuvėje arba blaškymosi tarp skirtingų miestų valandas lankantis pas kažką, kas darė savo ritualinius gaminimo pasiaukojimus (nebūtinai pagal jūsų mėgstamą skonių paletę), privalomus susibėgimus, kamščius ir jėga brukamą šventinę muziką su filmais kaip į "nieko tokio" emocinio krūvio kategoriją. 
Noriu galėti patikėti, kad tos magijos dar lieka pakankamai, bet realybėje prieššventinis laikotarpis ir suplanuotas šventimas juk dažniau būna performatyvus negu nuoširdus, šiltas ir jaukus. 
Ta nata noriu priminti, kad visa tai vistiek yra neišvengiama ir siūlau visame chaose, lėkime ir socialiniuose ritualuose vistiek paieškoti sau grožio, prasmės ir įkvėpimo. Tik kaip?
          </Text>
          {/* <Box minH='1vw' />
          <Text  fontSize='xl'> 
Rengimasis, kuris įprastom gyvenimo aplinkybėmis yra automatizuotas procesas su asmeninėm išgrynintom ir optimizuotom formulėm (žinau, skamba kaip marketingo skyriaus slengas) tokiomis progomis irgi gali kiek apkarsti ar tapti iš pareigos daromu veiksmu, tai sugalvojau gudrybę, kaip sau perfrazuoti visą šventinę privalomybę ir atgauti daugiau savęs visame tame. Šventės ateina ir praeina su daug pokalbių apie šį bei tą, bet tikėtina - ne apie tai, kas jums dabar iš tikrųjų rūpi. Na, kas taip lengvai atveria savo širdies sopulius ir nerimus giminėms ir ima dalintis svarstymu apie skyrybas, politinę padėtį, klimato kaitą ar šokiruojantį didesnės apimties medicinių tyrimų trūkumą su moterimis ir jų sveikata? Visi truputį saugom savo tikrąsias mintis ir save, nuveždami į svečius savo abstraktesnę pokerface versiją. Ir nėra geresnio būdo dar geriau nukreipti dėmesio nuo ten, kur jums dabar skauda ar rūpi negu tiesiog pasimėgauti savo atrodymu. 
          </Text> */}
          <Box minH='1vw' />
          <Link to="/tinklarastis/kaledinis_vakarelis"> {/* Adjust the path to your desired route */}
        <Text pt='2' fontSize='xl' color='#FB8FFF' cursor='pointer' textAlign='right'>
          Skaityti toliau <Icon as={ChevronRightIcon} />
        </Text>
        </Link>
        </Box>
    </CardBody>
    </Center>
    </Card>
    </Center>
    <Box minH='2vw' />
    <Center>
    <Card border='1px' maxWidth="80vw" minWidth='60vw' shadow='none'>
      <CardHeader >
        <Box minH='1vw' />
        <Center>
          <Heading as='h1' sx={{ fontSize: '32px', fontFamily: 'Montserrat, sans-serif' }}>Kaip susikurti poveikį darantį stilių</Heading>
        </Center>
        <Box>
            <Stat>
                <StatHelpText mb='0' mt='4'>2025-05-13 </StatHelpText>
            </Stat>
        </Box>
      </CardHeader>
    <Center>
    <CardBody pt='0'>

        <Box>
          <Text pt='2' fontSize='xl'>
          Iš kokių esminių elementų susideda ne tik akiai maloni apsirengimo visuma, bet ir į savo pusę
galintis palenkti, geresnes sąlygas leidžiantis išsiderėti įvairiuose scenarijuose ir autoritetą bei
įtaką padedantis susikurti asmeninis stilius?
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Išgryninti esminiai elementai </Text><Text  fontSize='xl' display='inline'> 
           ir nereikalingų, dėmesį blaškančių detalių atsisakymas. Pavyzdžiui,
jeigu vadovaujate įmonei, kolektyvui ar dideliems procesams, rinkitės aiškią ir tvirtą struktūrą
turinčius drabužius, daugiau švarkų, minimalistiškesnę estetiką ir atsirinkit tik jums tinkančias
spalvas. Minimalizuokit smulkių raštų, pastelinių spalvų ir plaukiančių lininių komplektų vilkėjimą
darban.
          </Text>
          <Box minH='1vw' />
          <Link to="/tinklarastis/kaip_susikurti_poveiki_daranti_stiliu"> {/* Adjust the path to your desired route */}
        <Text pt='2' fontSize='xl' color='#FB8FFF' cursor='pointer' textAlign='right'>
          Skaityti toliau <Icon as={ChevronRightIcon} />
        </Text>
        </Link>
        </Box>
    </CardBody>
    </Center>
    </Card>
    </Center>
    <Box minH='2vw' />
    <Center>
    <Card border='1px' maxWidth="80vw" minWidth='60vw' shadow='none'>
      <CardHeader >
        <Box minH='1vw' />
        <Center>
          <Heading as='h1' sx={{ fontSize: '32px', fontFamily: 'Montserrat, sans-serif' }}>Spintos paruošimas pavasariui</Heading>
        </Center>
        <Box>
            <Stat>
                <StatHelpText mb='0' mt='4'>2025-03-30 </StatHelpText>
            </Stat>
        </Box>
      </CardHeader>
    <Center>
    <CardBody pt='0'>

        <Box>
          <Text pt='2' fontSize='xl'>
          Pavasaris jau čia (pagaliau!), o su juo kartu ir pokyčiai, reikalaujantys
emocinio, fizinio ir psichologinio prisitaikymo. Skamba kaip daug darbo, bet
tereikia leisti tam įvykti.
          </Text>
          <Text pt='2' fontSize='xl'>
Rituališkai atsinaujinimą kasmet pradedu nuo namų generalinio švarinimo ir
spintos paruošimo naujam lengvumo, išsilukštenimo ir suaktyvėjimo etapui.
Tik nebūtina spintos atšviežinimo daryti grandiozinių apimčių ir intensyvumo.
Nes ir pats pavasarėjimas Šiaurėje turi savo lėtą ir inertišką tempą. Tai nuo
ko pradėti?
          </Text>
          <Box minH='1vw' />
          <Link to="/tinklarastis/spintos_paruosimas_pavasariui"> {/* Adjust the path to your desired route */}
        <Text pt='2' fontSize='xl' color='#FB8FFF' cursor='pointer' textAlign='right'>
          Skaityti toliau <Icon as={ChevronRightIcon} />
        </Text>
        </Link>
        </Box>
    </CardBody>
    </Center>
    </Card>
    </Center>
    <Box minH='2vw' />
    <Center>
    <Card border='1px' maxWidth="80vw" minWidth='60vw' shadow='none'>
      <CardHeader >
        <Box minH='1vw' />
        <Center>
          <Heading as='h1' sx={{ fontSize: '32px', fontFamily: 'Montserrat, sans-serif' }}>Apie kelnių ilgį</Heading>
        </Center>
        <Box>
            <Stat>
                <StatHelpText mb='0' mt='4'>2025-03-23 </StatHelpText>
            </Stat>
        </Box>
      </CardHeader>
    <Center>
    <CardBody pt='0'>

        <Box>
          <Text pt='2' fontSize='xl'>
          Per savo ilgą klientų aprengimo karjerą parduotuvių matavimosi kabinose
esu dalyvavusi įvairiuose aptarimuose ir vertinimuose apie drabužio gulimą
ant kūno. Tuose pokalbiuose gimsta tiesa arba bent jau apsikeitimas savo
realybės vertinimu. Bet jeigu pokalbis pakrypsta panašia linkme kaip "visai
gražiai man čia ir per pečius, ir nugaroj. Spalva labai patinka, tik rankovės
per trumpos" - tai dažniausiai reiškia, kad buvo priimtas aiškus ir
neginčytinas sprendimas to drabužio dėvėtojui ir pirkėjui. Per trumpos
rankovės, nepriklausomai nuo pasikaustymo mados lauke, amžiaus ir
gyvenimo patirties yra universaliai nepageidaujama ir netoleruotina situacija.
Kaip koks prie batų prikibęs tualetinis popierius. Mane ši rankovių ilgio
vertinimo konstanta net savotiškai ramina pasaulyje, kuriame viskas nuolat
kinta milžinišku greičiu. Tik kodėl tai universaliai neatsispindi perkant kelnes?
Jų ilgis taip pat yra iškalbingas ir principingai pasirinktos ne per trumpos
kelnės visą įvaizdį gali kilstelti į sofistikuotą arba bent jau adekvatų,
bendražmogiškai kultūringą lygį. O mes juk kultūringi žmonės? Noriu jums
padėti priimti sau naudingesnius sprendimus kitą kartą perkant džinsus,
kelnes, ar kombinezoną. Visas reikalas yra tikrai nesudėtingas.
          </Text>
          <Box minH='1vw' />
          <Link to="/tinklarastis/apie_kelniu_ilgi"> {/* Adjust the path to your desired route */}
        <Text pt='2' fontSize='xl' color='#FB8FFF' cursor='pointer' textAlign='right'>
          Skaityti toliau <Icon as={ChevronRightIcon} />
        </Text>
        </Link>
        </Box>
    </CardBody>
    </Center>
    </Card>
    </Center>
    <Box minH='2vw' />
    </>
    )
  }